import { recentSearchQueryKeys as e } from "./useRecentSearchQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { recentSearchesApi as r } from "@maat/api-main";
//#region src/recentSearches/useDismissRecentSearchMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.dismiss(e),
		onMutate: async (t) => {
			await i.cancelQueries({ queryKey: e.list() }), i.setQueriesData({ queryKey: e.list() }, (e) => e && { items: e.items.filter((e) => e.id !== t) });
		},
		onSettled: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useDismissRecentSearchMutation };
